import { Injectable, signal, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { GlobalMessageType } from '@spartacus/core';

export interface SessionMessage {
  type: GlobalMessageType;
  message: string;
  expiresAt: number;
}

@Injectable({
  providedIn: 'root',
})
export class SessionMessageStorageService {
  private readonly STORAGE_KEY = 'session-message';

  readonly message = signal<SessionMessage | null>(null);

  private platformId = inject(PLATFORM_ID);

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
  constructor() {

    if (this.isBrowser) {
      this.restoreMessage();
    }

  }

  setMessage(type: SessionMessage['type'], message: string, ttlInSeconds: number = 30): void {
    if (this.isBrowser) {
      const payload: SessionMessage = {
        type,
        message,
        expiresAt: Date.now() + ttlInSeconds * 1000,
      };

      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(payload));

      this.message.set(payload);
    }
  }

  restoreMessage(): void {
    const raw = sessionStorage.getItem(this.STORAGE_KEY);

    if (!raw) {
      return;
    }

    try {
      const parsed: SessionMessage = JSON.parse(raw);

      const isExpired = Date.now() > parsed.expiresAt;

      if (isExpired) {
        this.clearMessage();
        return;
      }

      this.message.set(parsed);
    } catch {
      this.clearMessage();
    }
  }

  getMessage(): SessionMessage | null {
    const current = this.message();

    if (!current) {
      return null;
    }

    const isExpired = Date.now() > current.expiresAt;

    if (isExpired) {
      this.clearMessage();
      return null;
    }

    return current;
  }

  clearMessage(): void {

    if (this.isBrowser) {
      sessionStorage.removeItem(this.STORAGE_KEY);
      this.message.set(null);
    }
  }
  getMessageFromStorage(): SessionMessage | null {
    if (this.isBrowser) {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);

      if (!stored) {
        return null;
      }

      const message: SessionMessage = JSON.parse(stored);

      if (Date.now() > message.expiresAt) {
        this.clearMessage();
        return null;
      }

      return message;
    }
    return null
  }
}
